var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / KH") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-KH",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0F3EB6",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0F3EB6",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#ED1A3C",
    mask: "url(#mask-2)",
    x: 0,
    y: 5.33333333,
    width: 28,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,10.6666667 L11.3333333,13.3333333 L8.66666667,13.3333333 L10,10.6666667 L11.3333333,10.6666667 Z M16,10.6666667 L16,13.3333333 L12,13.3333333 L12,10.6666667 L16,10.6666667 Z M18,10.6666667 L19.3333333,13.3333333 L16.6666667,13.3333333 L16.6666667,10.6666667 L18,10.6666667 Z M17.3333333,8 C17.7015232,8 18,8.29510689 18,8.66597104 L18,10 L16.6666667,10 L16.6666667,8.66597104 C16.6666667,8.33160227 16.9112203,8.05478743 17.2342396,8.00722084 L17.3333333,8 Z M14,7.33333333 C14.3681898,7.33333333 14.6666667,7.62893947 14.6666667,7.997615 L14.6666667,8.72721354 L16,8.72721354 L16,10 L12,10 L12,8.72721354 L13.3333333,8.72721354 L13.3333333,7.997615 C13.3333333,7.66409443 13.577887,7.38798178 13.9009063,7.34053585 L14,7.33333333 Z M10.6666667,8 C11.0348565,8 11.3333333,8.29510689 11.3333333,8.66597104 L11.3333333,10 L10,10 L10,8.66597104 C10,8.33160227 10.2445536,8.05478743 10.567573,8.00722084 L10.6666667,8 Z",
    id: "Rectangle-621",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKh);
export default __webpack_public_path__ + "static/media/KH.ab04e4b811704e7e75cf41c0d5bfb763.svg";
export { ForwardRef as ReactComponent };